import axios from 'axios';

const DEBUG = true; // desative em prod
const log = (...a: any[]) => DEBUG && console.log(...a);
const logErr = (...a: any[]) => DEBUG && console.error(...a);

const hasCookie = (name: string) =>
    document.cookie.split('; ').some(c => c.startsWith(`${name}=`));

export const api = axios.create({
    baseURL: '/api',
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

// Request log
api.interceptors.request.use((cfg) => {
    (cfg as any)._t0 = performance.now?.() ?? Date.now();
    const xsrfCookie = hasCookie('XSRF-TOKEN') ? 'present' : 'missing';
    console.log('[API][req]', (cfg.method||'GET').toUpperCase(), cfg.url, {
        withCredentials: cfg.withCredentials,
        xsrfCookie,
    });
    return cfg;
});

// Response log
api.interceptors.response.use(
    (res) => {
        const t0 = (res.config as any)._t0 ?? Date.now();
        const dt = Math.round((performance.now?.() ?? Date.now()) - t0);
        log('[API][res]', res.status, (res.config.method || 'GET').toUpperCase(), res.config.url, `${dt}ms`);
        return res;
    },
    async (error) => {
        const { response, config } = error || {};
        const status = response?.status;
        const method = (config?.method || 'GET').toUpperCase();
        const url = config?.url;

        logErr('[API][err]', status, method, url, {
            data: response?.data,
            headers: response?.headers,
        });

        // 419: CSRF expirado -> revalida e repete
        if (status === 419 && !config._retry) {
            log('[API][csrf] expirada, renovando…');
            config._retry = true;
            try {
                await api.get('/sanctum/csrf-cookie');
                log('[API][csrf] ok, repetindo requisição');
                return api.request(config);
            } catch (e) {
                logErr('[API][csrf] falhou na renovação', e);
            }
        }

        // 401: não autenticado
        if (status === 401) {
            log('[API][auth] 401 não autenticado');
        }

        return Promise.reject(error);
    }
);
